import { isAndroidEnv, isIOSAppEnv } from "../utils/env";

export class AppMetadata {
  constructor(init?: Partial<AppMetadata>) {
    Object.assign(this, init);

    this.platform = this.platform ?? "web";
  }

  appVersion?: string;
  buildNumber?: string;
  platform?: string;
  osVersion?: string;
  device?: string;
  deviceID?: string;
  deviceModel?: string;
  signedInParentIDs?: string[];
  hostAppSupportedFlows?: string[];
  // custom identifier for the host app where dojo islands is being embedded,
  // i.e. are we running on android native web view or android rn web view?
  hostId?: string;
}

export const HOST_APP_FLOWS = {
  LOGIN_WITH_OPEN_SIGNUP: "logInWithOpenSignup",
  NAVIGATE_TO_ISLAND_MAP: "navigateToIslandMap",
  ISLAND_MAP_IN_GAME_NAVIGATION: "islandMapInGameNavigation",
};

export function platformFromUserAgent(): string {
  return isAndroidEnv() ? "android" : isIOSAppEnv() ? "ios" : "web";
}

export function appVersionFromUserAgent(): string | undefined {
  function extractAppVersion(appName: string) {
    const regex = new RegExp(`${appName}/(\\S+)`);
    return navigator.userAgent.match(regex)?.[1] ?? undefined;
  }

  return isAndroidEnv()
    ? extractAppVersion("com.classdojo.android")
    : isIOSAppEnv()
      ? extractAppVersion("ClassDojo")
      : undefined;
}
